import {
  NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCPHIEUXUAT_HISTORY_LIST_SUCCESS,
  NEWDANHMUCPHIEUXUAT_IMPORT_SUCCESS,
  NEWDANHMUCPHIEUXUAT_LIST_SUCCESS,
  NEWDANHMUCPHIEUXUAT_NEW_CARE_SUCCESS,
  NEWDANHMUCPHIEUXUAT_ONE_SUCCESS,
  NEWDANHMUCPHIEUXUAT_UPDATE_FILTER,
  NEWDANHMUCPHIEUXUAT_SAVE_SUCCESS,
  NEWDANHMUCPHIEUXUAT_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCPHIEUXUAT_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucphieuxuat.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucphieuxuatFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucphieuxuatPage: 0,
    homepageNewdanhmucphieuxuatLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucphieuxuatItems: [],
  homepageNewdanhmucphieuxuatTotal: 0,
  homepageNewdanhmucphieuxuatSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucphieuxuatReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCPHIEUXUAT_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCPHIEUXUAT_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCPHIEUXUAT_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCPHIEUXUAT_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucphieuxuatFilter !== 'undefined' && state.homepageNewdanhmucphieuxuatFilter) {
        if (action.data.homepageNewdanhmucphieuxuatPage == 'no_update' && typeof state.homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatPage !== 'undefined') action.data.homepageNewdanhmucphieuxuatPage = state.homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatPage;
        if (action.data.homepageNewdanhmucphieuxuatLimit == 'no_update' && typeof state.homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatLimit !== 'undefined') action.data.homepageNewdanhmucphieuxuatLimit = state.homepageNewdanhmucphieuxuatFilter.homepageNewdanhmucphieuxuatLimit;
      }
      return {
        ...state,
        homepageNewdanhmucphieuxuatFilter: action.data,
      }
    }
    case NEWDANHMUCPHIEUXUAT_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucphieuxuatItems: action.data.homepageNewdanhmucphieuxuatItems,
        homepageNewdanhmucphieuxuatTotal: action.data.homepageNewdanhmucphieuxuatTotal,
      }
    }
    case NEWDANHMUCPHIEUXUAT_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucphieuxuatSelected: action.data
      }
    }
    case NEWDANHMUCPHIEUXUAT_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCPHIEUXUAT_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCPHIEUXUAT_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCPHIEUXUAT_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCPHIEUXUAT_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCPHIEUXUAT_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucphieuxuatReducer